import { createSelector } from "@reduxjs/toolkit";
import { selectUniqueSpecifiedArticlesKeys } from "../../Room/drofusOccurrenceValidationColoringSelectors";
import { IValidationColumnMeta } from "./roomTableDrofusOccurrenceStandardValidationSelectors";
import { parseDrofusOccurrenceValidationColoringId } from "../../DrofusOccurrenceValidation/drofusOccurrenceValidationIds";

const formatPct1 = (value: unknown) => {
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? `${n.toFixed(1)} %` : "–";
};

export const selectSpecifiedArticlesValidationColumnMetas = createSelector(
  [selectUniqueSpecifiedArticlesKeys],
  (keys): IValidationColumnMeta[] => {
    const columns: IValidationColumnMeta[] = [];

    keys.forEach((key) => {
      const scope = parseDrofusOccurrenceValidationColoringId(key);

      // overall
      if (!scope || scope.type === "overall") {
        columns.push({
          id: `${key}.summary.matchRatePct`,
          header: "Forekomster samlet andel matchet",
          valuePath: ["validation", "specifiedArticles", "summary", "matchRatePct"],
          tooltip: "Treffsikkerhet basert på artikkelspesifikasjon (0–100 %).",
          valueFormatter: formatPct1,
        });
        return;
      }

      if (scope.type === "listType") {
        columns.push({
          id: `${key}.summary.matchRatePct`,
          header: `Forekomster ${scope.value} andel matchet`,
          valuePath: [
            "validation",
            "specifiedArticles",
            "perListType",
            scope.value,
            "summary",
            "matchRatePct",
          ],
          tooltip: `Treffsikkerhet for dRofus-liste "${scope.value}" (0–100 %).`,
          valueFormatter: formatPct1,
        });
        return;
      }

      columns.push({
        id: `${key}.summary.matchRatePct`,
        header: `Forekomster ansvar ${scope.value} andel matchet`,
        valuePath: [
          "validation",
          "specifiedArticles",
          "perResponsibility",
          scope.value,
          "summary",
          "matchRatePct",
        ],
        tooltip: `Treffsikkerhet for ansvar "${scope.value}" (0–100 %).`,
        valueFormatter: formatPct1,
      });
    });

    return columns;
  }
);
